var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./Header.module.scss";
import { getSettings, getTranslation } from "../../constants/setting";
import { LANGUAGES, getLanguageFullName } from "../../../../constants";
import { useSelector } from "react-redux";
import { currentLanguage } from "../../stores/reducers/chatReducer";
import { getTextColor } from "../../helper";
import { sortBy } from "lodash";
var Header = function (props) {
    var _b = getSettings(), logo = _b.logo, name = _b.name, secondary_color = _b.secondary_color, display_chatbot_name = _b.display_chatbot_name, header_text_color = _b.header_text_color;
    var onClickMinimize = props.onClickMinimize, onChangeLanguage = props.onChangeLanguage;
    var language = useSelector(currentLanguage);
    var languages = sortBy(Object.keys(LANGUAGES).map(function (abbr) {
        return {
            id: abbr,
            // @ts-ignore
            abbr: LANGUAGES[abbr],
            name: getLanguageFullName(abbr)
        };
    }), 'name');
    var onLanguageChange = function (e) {
        onChangeLanguage(e.target.value);
    };
    var isMobile = function () {
        return window.innerWidth < 469 || window.innerHeight < 469;
    };
    return _jsxs("div", __assign({ className: styles.header, style: {
            backgroundColor: secondary_color,
            color: header_text_color || getTextColor(secondary_color)
        } }, { children: [_jsxs("div", __assign({ className: styles.baseHeader }, { children: [_jsx("img", { className: styles.logo, src: logo, crossOrigin: "anonymous", alt: "Always On" }), _jsx("span", __assign({ className: styles.name, style: {
                            display: display_chatbot_name ? '' : "none"
                        } }, { children: name }))] })), _jsx("div", __assign({ className: styles.languagePicker }, { children: _jsx("select", __assign({}, { tabIndex: 0 }, { className: styles.languagePickerField, onChange: onLanguageChange, value: language }, { children: // @ts-ignore
                    languages.map(function (languageItem) { return _jsx("option", __assign({ value: languageItem.abbr }, { children: languageItem.name }), languageItem.id); }) })) })), _jsx("button", __assign({}, { tabIndex: 0 }, { style: {
                    color: header_text_color || getTextColor(secondary_color)
                }, type: "button", className: styles.minimize, onClick: onClickMinimize }, { children: isMobile() ? getTranslation('chatbot.close') : '-' }))] }));
};
export default Header;
